import React from 'react'
import { List } from 'immutable'
import { ILocalizedLanguage } from 'store/locale/types'
import { useStyles } from './LanguageSelector.styles'
import { navigate } from 'hookrouter'
import { useLanguage } from '../../../store/locale/hooks/useLanguage'
import { useArticle } from '../../../hooks/useArticle'

interface ILanguageSelectorProps {
  active: string
  languages: List<ILocalizedLanguage>
  onSelect: (language: string) => void
}

export const LanguageSelector = ({ active, languages, onSelect }: ILanguageSelectorProps) => {
  const classes = useStyles()
  const { language } = useLanguage()

  const isArticle =
    window.location.pathname.split('/')[2] === 'actualites' &&
    window.location.pathname !== `/${language}/actualites/all/all`

  const handleTranslatedLink = (link) => {
    navigate(`/${language === 'en' ? 'fr' : 'en'}/actualites/article/${link}`)
  }

  const { article } = useArticle(window.location.pathname.split('/')[4])

  const handleChangeLanguage = (code) => {
    if (!isArticle) {
      onSelect(code)
    } else {
      if (article) {
        const translatedLink = article.translatedLink
        handleTranslatedLink(translatedLink)
      }
    }
  }

  return (
    <div className={classes.root}>
      {languages.map(({ code, name, shortName }) => {
        const className = active === code ? classes.active : classes.inactive
        return (
          <span
            key={`language-selector-${code}`}
            title={name}
            className={`${classes.language} ${className}`}
            onClick={() => handleChangeLanguage(code)}
            onKeyDown={() => handleChangeLanguage(code)}
            role="button"
            tabIndex={0}
          >
            {shortName}
          </span>
        )
      })}
    </div>
  )
}
